import ChatView from "@/components/ChatView";
export default function Chat() { return <ChatView origin="tenant"/>; }
